import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3715938"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "case-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "icon-box"
}
const _hoisted_4 = { class: "subpages" }
const _hoisted_5 = {
  key: 1,
  class: "h-100 d-case-wrapper d-case-popup"
}
const _hoisted_6 = { class: "d-case-popup__right" }
const _hoisted_7 = { class: "case-header" }
const _hoisted_8 = { class: "case-header__items" }
const _hoisted_9 = { class: "case-header__cases-link" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "case-header__icons" }
const _hoisted_13 = { class: "case-user" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "case-user__info" }
const _hoisted_16 = { class: "case-user__info-title" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "case-user__info-name" }
const _hoisted_21 = { class: "name" }
const _hoisted_22 = { class: "text" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "case-main" }
const _hoisted_25 = { class: "case-main__photos" }
const _hoisted_26 = { class: "case-main__info" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case-main__info-status" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_drive_shared_bar = _resolveComponent("drive-shared-bar")!
  const _component_drive_photo_carousel = _resolveComponent("drive-photo-carousel")!
  const _component_drive_overview = _resolveComponent("drive-overview")!
  const _component_drive_files = _resolveComponent("drive-files")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!
  const _component_case_settings_pop_up = _resolveComponent("case-settings-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!
  const _component_app_skeleton_case_view = _resolveComponent("app-skeleton-case-view")!
  const _component_drive_tooltip = _resolveComponent("drive-tooltip")!
  const _component_app_header_upload_progress = _resolveComponent("app-header-upload-progress")!
  const _component_drive_case_photos = _resolveComponent("drive-case-photos")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_header, {
          customTitle: _ctx.caseCopyTitle || _ctx.title,
          countPadding: ""
        }, {
          "top-left": _withCtx(() => [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('cancel')), ["prevent"])),
              class: "back-link"
            }, [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$localize('drive.view.case.backtext')), 1)
            ])
          ]),
          "top-right": _withCtx(() => [
            (_ctx.selector)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doneAction && _ctx.doneAction(...args)), ["prevent"])),
                  class: "back-link"
                }, _toDisplayString(_ctx.$localize('message.case.selector.done.button')), 1))
              : _createCommentVNode("", true),
            (_ctx.toShare || _ctx.allowSave)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.toShare)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "icon icon-share",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSharePopUp(_ctx.driveStore.currentCase!, _ctx.SHARE_TYPES.CASE)))
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.allowSave)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "icon icon-dots",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isCaseSettingsPopUp = true))
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["customTitle"]),
        (_ctx.isMy)
          ? (_openBlock(), _createBlock(_component_drive_shared_bar, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_drive_photo_carousel, {
          class: "photo-carousel",
          onSelectPhoto: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectPhoto($event))),
          onSelectVideo: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectVideo($event))),
          isPreviewCase: true,
          "is-swiper": ""
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_drive_overview, { isPreviewCase: true }),
          _createVNode(_component_drive_files, { isPreviewCase: true })
        ]),
        (_ctx.sharedPopUp.item)
          ? (_openBlock(), _createBlock(_component_share_pop_up, {
              key: 1,
              item: _ctx.sharedPopUp.item,
              "item-type": _ctx.sharedPopUp.type!,
              onHide: _ctx.closeSharePopUp,
              onSetItemShared: _ctx.setItemShared,
              onSetSharedLabels: _ctx.setSharedLabels,
              onOnShareByMessage: _ctx.removeSharedItemFromStore
            }, null, 8, ["item", "item-type", "onHide", "onSetItemShared", "onSetSharedLabels", "onOnShareByMessage"]))
          : _createCommentVNode("", true),
        (_ctx.isCaseSettingsPopUp)
          ? (_openBlock(), _createBlock(_component_case_settings_pop_up, {
              key: 2,
              "i-case": _ctx.driveStore.currentCase!,
              onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isCaseSettingsPopUp = false)),
              onOpenMovePopUp: _ctx.openMovePopUp,
              onDeleteCase: _ctx.deleteCase,
              onSaveCaseAsCopy: _ctx.saveCaseAsCopy
            }, null, 8, ["i-case", "onOpenMovePopUp", "onDeleteCase", "onSaveCaseAsCopy"]))
          : _createCommentVNode("", true),
        (_ctx.isMoveToCasePopUp)
          ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
              key: 3,
              item: _ctx.driveStore.currentCase!,
              "item-type": _ctx.SHARE_TYPES.CASE,
              onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isMoveToCasePopUp = false)),
              onUpdateLocation: _ctx.updateLocation
            }, null, 8, ["item", "item-type", "onUpdateLocation"]))
          : _createCommentVNode("", true),
        (_ctx.caseLoading || _ctx.isCaseCopying)
          ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
              key: 4,
              title: _ctx.title,
              photoSkeletons: _ctx.photoSkeletons,
              fileSkeletons: _ctx.fileSkeletons
            }, null, 8, ["title", "photoSkeletons", "fileSkeletons"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.isMy)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.viewAllCases && _ctx.viewAllCases(...args)))
                    }, _toDisplayString(_ctx.$localize('drive.your.cases')), 1))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.viewNetworkCases && _ctx.viewNetworkCases(...args)))
                    }, _toDisplayString(_ctx.$localize('drive.desktop.network.cases')), 1))
              ]),
              _hoisted_10,
              _createElementVNode("div", {
                class: "case-header__title",
                innerHTML: _ctx.descriptionWithLink(_ctx.driveStore.currentCase.title)
              }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.toShare)
                ? (_openBlock(), _createBlock(_component_drive_tooltip, {
                    key: 0,
                    text: "Share case",
                    isPopUp: true,
                    class: "case-header__tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "icon icon-share",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.openSharePopUp(_ctx.driveStore.currentCase!, _ctx.SHARE_TYPES.CASE); _ctx.getPosition($event)})
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.allowSave)
                ? (_openBlock(), _createBlock(_component_drive_tooltip, {
                    key: 1,
                    text: "Save case as copy",
                    isPopUp: true,
                    class: "case-header__tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "icon icon-copy-content",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.saveCaseAsCopy && _ctx.saveCaseAsCopy(...args)))
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isMy)
                ? (_openBlock(), _createBlock(_component_drive_tooltip, {
                    key: 2,
                    text: "Edit case",
                    isPopUp: true,
                    class: "case-header__tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "icon icon-edit",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.editCase && _ctx.editCase(...args)))
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isMy)
                ? (_openBlock(), _createBlock(_component_drive_tooltip, {
                    key: 3,
                    text: "Delete case",
                    isPopUp: true,
                    class: "case-header__tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "icon icon-trash",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.deleteCase && _ctx.deleteCase(...args)))
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isMy)
                ? (_openBlock(), _createBlock(_component_drive_tooltip, {
                    key: 4,
                    text: "Move case",
                    isPopUp: true,
                    class: "case-header__tooltip item-folder"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "icon icon-move-folder",
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openMovePopUp && _ctx.openMovePopUp(...args)))
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_drive_tooltip, {
                text: "Close",
                isPopUp: true,
                class: "case-header__tooltip item-folder"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: "icon icon-close",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('cancel')))
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "case-user__photo circle",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.viewProfile && _ctx.viewProfile(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.photoUrl,
                alt: "profile photo"
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$localize('drive.creation.info.person')), 1),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$localize('drive.creation.info.created')), 1),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$localize('drive.creation.info.updated')), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.fullName), 1),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.createdDate), 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.updatedDate), 1)
              ])
            ])
          ]),
          (_ctx.isMy)
            ? (_openBlock(), _createBlock(_component_drive_shared_bar, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.mainStore.uploadInfos.length)
            ? (_openBlock(), _createBlock(_component_app_header_upload_progress, {
                key: 1,
                uploadInfo: _ctx.mainStore.getUploadInfo
              }, null, 8, ["uploadInfo"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_drive_case_photos, {
                isPreviewCase: !_ctx.isMy
              }, null, 8, ["isPreviewCase"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_drive_overview, {
                "is-preview-case": !_ctx.isMy
              }, null, 8, ["is-preview-case"]),
              _createVNode(_component_drive_files, {
                isPreviewCase: !_ctx.isMy
              }, null, 8, ["isPreviewCase"]),
              _hoisted_27
            ])
          ]),
          (_ctx.sharedPopUp.item)
            ? (_openBlock(), _createBlock(_component_share_pop_up, {
                key: 2,
                item: _ctx.sharedPopUp.item,
                "item-type": _ctx.sharedPopUp.type,
                positionData: _ctx.positionData,
                onHide: _ctx.closeSharePopUp,
                onSetItemShared: _ctx.setItemShared,
                onSetSharedLabels: _ctx.setSharedLabels,
                onOnShareByMessage: _ctx.removeSharedItemFromStore
              }, null, 8, ["item", "item-type", "positionData", "onHide", "onSetItemShared", "onSetSharedLabels", "onOnShareByMessage"]))
            : _createCommentVNode("", true),
          (_ctx.isMoveToCasePopUp)
            ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
                key: 3,
                item: _ctx.driveStore.currentCase!,
                "item-type": _ctx.SHARE_TYPES.CASE,
                onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isMoveToCasePopUp = false)),
                onUpdateLocation: _ctx.updateLocation
              }, null, 8, ["item", "item-type", "onUpdateLocation"]))
            : _createCommentVNode("", true)
        ])
      ]))
}